// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1NMRn","vLegacy":"SelectSecondary_vLegacy__KmQZK","error":"SelectSecondary_error__J61jl","disabled":"SelectSecondary_disabled__2GcGt"};